var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdCalFairlyoften(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    d: "M2 5.52h42v8H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44 5.52v8H2v-8h42m0-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h42a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44 5.52v40H2v-40h42m0-2H2a2 2 0 0 0-2 2v40a2 2 0 0 0 2 2h42a2 2 0 0 0 2-2v-40a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13 2.48a1 1 0 0 1 1 1v3.86a1 1 0 0 1-2 0V3.48a1 1 0 0 1 1-1m0-2a3 3 0 0 0-3 3v3.86a3 3 0 0 0 6 0V3.48a3 3 0 0 0-3-3zM33 2.48a1 1 0 0 1 1 1v3.86a1 1 0 0 1-2 0V3.48a1 1 0 0 1 1-1m0-2a3 3 0 0 0-3 3v3.86a3 3 0 0 0 6 0V3.48a3 3 0 0 0-3-3z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5.86,
    x: 12,
    y: 2.48,
    fill: "#BFBFBF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5.86,
    x: 32,
    y: 2.48,
    fill: "#BFBFBF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    d: "M2 11.52h42v2H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M4 17.24h6v5H4zM20 17.24h6v5h-6zM28 17.24h6v5h-6zM36 17.24h6v5h-6zM4 24.24h6v5H4zM12 24.24h6v5h-6zM28 24.24h6v5h-6zM36 24.24h6v5h-6zM4 31.24h6v5H4zM12 31.24h6v5h-6zM20 31.24h6v5h-6zM28 31.24h6v5h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M12 17.24h6v5h-6zM20 24.24h6v5h-6zM36 31.24h6v5h-6zM4 38.24h6v5H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M12 38.24h6v5h-6zM20 38.24h6v5h-6zM28 38.24h6v5h-6zM36 38.24h6v5h-6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdCalFairlyoften);
export default __webpack_public_path__ + "static/media/ic_md_cal_fairlyoften.4ddcb889fe845fa40333c4adb3182670.svg";
export { ForwardRef as ReactComponent };